<template>
  <div
    v-if="showLoadingState < 1"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div
    v-else
    key="productosListado"
  >
    <div class="align-items-baseline display-flex-row">
      <form
        autocomplete="off"
        class="m-form-row m-form-search"
        name="simple-filters-form"
        @submit.prevent="readProductos"
        >
        <AtomInputPrimary
            v-model="filtro.search"
            :disabled="pagination.showLoadingState"
            v-on:keyup.enter="readProductos"
            name="nombreProducto"
            placeholder="Nombre del producto"
            type="text"
            wrapperClass="a-input-wrapper-row"
        />
        <AtomSelectPrimary
          v-model.number="filtro.producto_vidroop"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.producto_vidroop"
          keyField="id"
          name="tipoProducto"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readProductos"
        />
        <AtomSelectPrimary
          v-model.number="filtro.activo"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.activo"
          keyField="id"
          name="activo"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readProductos"
        />
        <AtomSelectPrimary
          v-model.number="filtro.visible"
          :disabled="pagination.showLoadingState"
          :elements="selectPrimary.visible"
          keyField="id"
          name="visible"
          textField="name"
          wrapperClass="a-input-wrapper-row"
          @change="readProductos"
        />
        <AtomButtonSecondary
          :button-secondary="buttonSecondary.reset"
          :disabled="pagination.showLoadingState"
          @resetFilter="resetFilter"
        />
      </form>
      <AtomButtonSecondary
        :button-secondary="buttonSecondary.create"
        @createProducto="createProducto"
      />
    </div>
    <div
      v-if="productos.length"
      class="m-table-primary"
    >
      <table>
        <tr>
          <th
            class="text-align-left"
            width="40%"
          >
            NOMBRE
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ESTADO ACTIVO
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ESTADO TIENDA
          </th>
          <th
            class="text-align-center"
            width="20%"
          >
            ACCIONES
          </th>
        </tr>
        <tr
          v-for="producto in productos"
          :key="producto.id"
          class="row-data"
        >
          <td class="text-align-left">
            {{ producto.nombre }}
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-if="false"
              v-model="producto.activo"
              disabled="true"
              :element-id="producto.id"
              method="updateProductosActivo"
              name="activo"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updateProductosActivo="updateProductosActivo"
            />
            <span
              v-if="producto.activo"
              class="font-weight-regular text-color-billing-primary"
            >
              Activo
            </span>
            <span
              v-else
              class="font-weight-regular text-color-assets-primary"
            >
              Deshabilitado
            </span>
          </td>
          <td class="text-align-center">
            <AtomTogglePrimary
              v-if="false"
              v-model="producto.visible"
              disabled="true"
              :element-id="producto.id"
              method="updateProductosVisible"
              name="activo"
              sliderClass="a-toggle-slider-billing-primary"
              type="checkbox"
              @updateProductosVisible="updateProductosVisible"
            />
            <span
              v-if="producto.visible"
              class="font-weight-regular text-color-billing-primary"
            >
              Visible
            </span>
            <span
              v-else
              class="font-weight-regular text-color-assets-primary"
            >
              Oculto
            </span>
          </td>
          <td class="text-align-center">
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.edit"
              :element="producto.id"
              @editProducto="editProducto"
            />
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.cart"
              :element="producto.id"
              @goToMarketPlace="goToMarketPlace"
            />
            <AtomButtonIconRounded
              :button-icon-rounded="buttonIconRounded.delete"
              :element="producto.id"
              @deleteProducto="deleteProducto"
            />
          </td>
        </tr>
      </table>
      <MoleculePaginationPrimary
        :pagination="pagination"
        @setPaginationCurrentPage="setPaginationCurrentPage"
      />
    </div>

  </div>

</template>

<script>
export default {
  name: 'MoleculeEditionBillingProducts',

  components: {
    MoleculePaginationPrimary: () => import('@/components/molecules/MoleculePaginationPrimary')
  },

  props: {
    element: Object,
    position: String
  },

  data () {
    return {
      academiaId: '',

      buttonIconRounded: {
        cart: {
          class: 'a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'far fa-shopping-bag',
          method: 'goToMarketPlace',
          tooltip: 'Acceder',
          type: 'button'
        },

        edit: {
          class: 'a-button-no-border a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'far fa-pencil-alt',
          method: 'editProducto',
          tooltip: 'Editar',
          type: 'button'
        },

        delete: {
          class: 'a-button-no-border a-button-secondary a-button-danger-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom margin-left-xsmall margin-right-xsmall',
          component: '',
          icon: 'far fa-trash-alt',
          method: 'deleteProducto',
          tooltip: 'Eliminar',
          type: 'button'
        }
      },

      buttonSecondary: {
        create: {
          class: 'a-button-billing-secondary a-button-side margin-left-auto',
          component: '',
          icon: 'far fa-plus margin-right-xsmall',
          method: 'createProducto',
          text: 'Crear Producto',
          type: 'button'
        },

        reset: {
          class: 'a-button-secondary a-button-billing-secondary a-button-side a-tooltip-primary a-tooltip-bottom',
          component: '',
          icon: 'fas fa-sync-alt',
          method: 'resetFilter',
          text: '',
          tooltip: this.$t('mEditionBillingAcademySales.tooltip.restart'),
          type: 'button'
        }
      },

      filtro: {
        search: '',
        visible: '',
        activo: '',
        producto_vidroop: '',
        categoria: 0,
        pagina: 1,
        limite: 10
      },

      selectPrimary: {
        activo: [
          {
            id: '',
            name: 'Estado activo'
          },
          {
            id: 0,
            name: 'Deshabilitado'
          },
          {
            id: 1,
            name: 'Activo'
          }
        ],

        producto_vidroop: [
          {
            id: '',
            name: 'Todos los productos'
          },
          {
            id: 0,
            name: 'Productos sin licencias'
          },
          {
            id: 1,
            name: 'Productos con licencia'
          }
        ],

        visible: [
          {
            id: '',
            name: 'Estado tienda'
          },
          {
            id: 0,
            name: 'Oculto'
          },
          {
            id: 1,
            name: 'Visibles'
          }
        ]
      },

      pagination: {
        currentPage: 1,
        currentQuantity: 0,
        limit: 10,
        showLoadingState: false,
        totalPages: 1,
        totalQuantity: 0
      },

      productos: {},

      showLoadingState: 0
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
    this.readProductos()
  },

  methods: {
    createProducto () {
      this.$router.push('/gestion/productos-de-vidroop/crear-producto')
    },

    deleteProducto (productoId) {
      this.$modal.showModal('MoleculeEditionBillingProductsModalDelete', productoId)
    },

    editProducto (productoId) {
      this.$router.push('/gestion/productos-de-vidroop/' + productoId + '/editar-producto')
    },

    goToMarketPlace (productoId) {
      window.open(`${this.$utils.getMarketPlaceDomain()}/${this.$store.getters.getAcademyData.url}/producto/${productoId}/comprar`, '_blank')
    },

    readProductos () {
      this.pagination.showLoadingState = true
      this.$services.read('producto', 'readProductos', {}, [this.academiaId], this.filtro)
        .then(response => {
          this.productos = response.data.productos

          this.pagination.currentQuantity = this.productos.length
          this.pagination.totalPages = response.data.pages
          this.pagination.totalQuantity = response.data.total
          this.pagination.showLoadingState = false

          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    setPaginationCurrentPage (page) {
      this.showLoadingState = 0
      this.filtro.pagina = page
      this.pagination.currentPage = page
      this.readProductos()
    },

    updateProductosActivo (element) {
      console.log('updateProductosActivo')
    },

    updateProductosVisible (element) {
      console.log('updateProductosVisible')
    },

    resetFilter () {
      this.filtro = {
        search: '',
        visible: '',
        activo: '',
        producto_vidroop: '',
        categoria: 0,
        pagina: 1,
        limite: 10
      }
      this.readProductos()
    }
  }
}
</script>
